import { render, staticRenderFns } from "./LimitField.vue?vue&type=template&id=52e22418&scoped=true&"
import script from "./LimitField.vue?vue&type=script&lang=js&"
export * from "./LimitField.vue?vue&type=script&lang=js&"
import style0 from "./LimitField.vue?vue&type=style&index=0&id=52e22418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e22418",
  null
  
)

export default component.exports